// extracted by mini-css-extract-plugin
export var divisionOne = "sessionList-module--division-one--e72bc";
export var divisionOneInPerson = "sessionList-module--division-one-in-person--78ce2";
export var divisionTwo = "sessionList-module--division-two--a499e";
export var divisionTwoInPerson = "sessionList-module--division-two-in-person--ce8cf";
export var eventDate = "sessionList-module--event-date--96cd2";
export var heading = "sessionList-module--heading--758ec";
export var headingContent = "sessionList-module--heading-content--fefe6";
export var jumpLink = "sessionList-module--jump-link--9c5cc";
export var mainContainer = "sessionList-module--main-container--7bcb9";
export var mainContainerInPerson = "sessionList-module--main-container-in-person--0dc2d";
export var modal = "sessionList-module--modal--66571";
export var moreButton = "sessionList-module--more-button--c0d31";
export var saveButton = "sessionList-module--save-button--4d335";
export var saveButtonMobile = "sessionList-module--save-button-mobile--9e6ab";
export var sessionList = "sessionList-module--session-list--1033b";
export var sessionSpeaker = "sessionList-module--session-speaker--d59a6";
export var sessionSpeakerInPerson = "sessionList-module--session-speaker-in-person--3532a";
export var sessionTime = "sessionList-module--session-time--c4e46";
export var sessionTimeInPerson = "sessionList-module--session-time-in-person--d65ed";
export var sessionTitle = "sessionList-module--session-title--9e969";
export var sessionType = "sessionList-module--session-type--48f2e";
export var sessionTypeAndDate = "sessionList-module--session-type-and-date--775ac";
export var sessionTypeInPerson = "sessionList-module--session-type-in-person--8046f";
export var speakerDetails = "sessionList-module--speaker-details--39d74";
export var speakerDetailsInPerson = "sessionList-module--speaker-details-in-person--c4f74";
export var speakerImageAvatar = "sessionList-module--speaker-image-avatar--a841d";
export var speakerImageAvatarInPerson = "sessionList-module--speaker-image-avatar-in-person--766b9";
export var speakerName = "sessionList-module--speaker-name--e0d19";
export var speakerNameInPerson = "sessionList-module--speaker-name-in-person--24626";
export var speakerTitle = "sessionList-module--speaker-title--58faf";
export var speakerTitleInPerson = "sessionList-module--speaker-title-in-person--971f9";
export var subContainer = "sessionList-module--sub-container--aded7";
export var subContainerInPerson = "sessionList-module--sub-container-in-person--49fe9";
export var venue = "sessionList-module--venue--72371";
export var venueInPerson = "sessionList-module--venue-in-person--e3183";
export var videoButton = "sessionList-module--video-button--e60a0";
export var whiteText = "sessionList-module--white-text--2de1e";